// extracted by mini-css-extract-plugin
export default {"dialog-content":"M7SCoYwfOk8LqBkFZtyZ"};